import { useIsomorphicLayoutEffect } from 'react-use';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

/**
 * The `ads:` variant in `@air/tailwind-config` (`plugins/ads.ts`) matches `html[data-ads-colors]`; keep the names in sync.
 */
export const useAdsColorsStyles = () => {
  const { adsColors } = useTemporaryFeatureFlags();

  useIsomorphicLayoutEffect(() => {
    const htmlElement = document.documentElement;

    if (adsColors) {
      htmlElement.setAttribute('data-ads-colors', '');
    } else {
      htmlElement.removeAttribute('data-ads-colors');
    }
  }, [adsColors]);
};
